import * as React from 'react'

export function SewingInst(props: {}) {

   return <div className="">
      <div className="embed-responsive embed-responsive-4by3 relative w-full overflow-hidden" style={{ paddingTop: "75%" }}>
      <iframe
         className="embed-responsive-item absolute bottom-0 left-0 right-0 top-0 h-full w-full rounded-2xl"
         src="https://www.youtube.com/embed/FwnMiKoTktE"
         allowFullScreen={true}
         data-gtm-yt-inspected-2340190_699="true"
         id="240632615"></iframe>
   </div>
   </div>
}